/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { SlideMetadataViewModel } from "../types/SlideMetadataViewModel.ts";

export const slideMetadataViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  classroomDisciplineId: z.optional(z.number().int()),
  index: z.optional(z.number().int()),
  cultureInfo: z.string().nullish(),
  fileName: z.string().nullish(),
  blobPath: z.string().nullish(),
  waterMark: z.optional(z.boolean()),
  isPdfSlideClass: z.optional(z.boolean()),
}) as unknown as ToZod<SlideMetadataViewModel>;
